import { SITE_NAME } from './site-config';

/**
 * Lo único que sirve `app.accesible.club` hoy: un cartel de "en construcción"
 * para el futuro catálogo de aplicaciones — no el sitio completo.
 *
 * Deliberadamente por fuera de `App.tsx`/`AppShell`: sin sesión, sin router,
 * sin cabecera del sitio — no necesita nada de eso todavía, y montarlos solo
 * para no usarlos sería trabajo (y riesgo) de más para una página estática.
 * Es la única página de este sitio que decide qué mostrar según el dominio
 * en vez de la ruta (ver `src/app/surface.ts`): una excepción puntual y
 * documentada, no el patrón general.
 */
export default function AppsPlaceholderPage() {
  return (
    <main className="container py-5" style={{ maxWidth: '40rem' }}>
      <p className="eyebrow">{SITE_NAME}</p>
      <h1>Aplicaciones</h1>
      <p className="lead">Este espacio va a alojar, más adelante, aplicaciones de {SITE_NAME}. Todavía no hay nada publicado acá.</p>
      <p>
        Mientras tanto, el sitio completo está en <a href="https://accesible.club">accesible.club</a>.
      </p>
    </main>
  );
}
